import { SvgIcon, SxProps } from "@mui/material";
import CommentSvg from "jsx:../../../Images/Icons/FontAwesome/solid/comment.svg";

export function CommentSolidIcon(props: SxProps) {
    return <SvgIcon component={CommentSvg} inheritViewBox sx={props} />;
}
